<template>
  <div class="ds-grid">
    <div
      v-if="video || image"
      class="ds-grid__col ds-grid__col--12 ds-margin-bottom-48"
    >
      <template v-if="video">
        <DsVideoElement
          v-if="videoAutoplay"
          v-bind="video"
          :screen="screen"
          data-j-video-autoplay
        />
        <DsVideoPlayer
          v-else
          v-bind="video"
          :screen="screen"
          :aria-label-play="labels.play"
          :aria-label-close="labels.close"
          data-j-video
        />
      </template>
      <DsImageElement
        v-else-if="image"
        :image="image"
        :screen="screen"
        data-j-image
      />
    </div>

    <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--6">
      <h2
        v-if="title"
        class="ds-heading"
      >
        {{ title }}
      </h2>
    </div>
    <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--6 ds-margin-top-12 ds-lg-margin-top-0">
      <RichText
        v-if="description"
        :data="description"
        class="ds-text"
      />
      <div
        v-if="link"
        class="ds-margin-top-12 ds-lg-margin-top-24"
      >
        <DsLink
          :content="link.title"
          :url="link.url"
          :nuxt="link.nuxt"
          :open-in-new-window="link.openInNewWindow"
          :icon-right="{ category: 'arrows', name: 'chevron-right-small' }"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { DsImageElement, DsVideoElement, DsVideoPlayer, DsLink } from 'awds'

const { labels } = useGlobalData()

defineProps({
  image: {
    type: Object,
    default: null
  },
  video: {
    type: Object,
    default: null
  },
  videoAutoplay: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: Object,
    default: null
  },
  link: {
    type: Object,
    default: null
  },
  screen: {
    type: String,
    required: true
  }
})
</script>
